import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "SaveBlock" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "SaveBlockTitle" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCampaignCreation)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "SaveBlockTitle" }, " Create Campaign ", -1 /* CACHED */)),
          _createElementVNode("button", {
            class: "ChampionButton SaveBlockButton",
            disabled: _ctx.isSaveOrCreationInProgress,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createCampaign && _ctx.createCampaign(...args)))
          }, " Create Campaign ", 8 /* PROPS */, _hoisted_2)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h1", _hoisted_3, " Edit Campaign - " + _toDisplayString(_ctx.pageName), 1 /* TEXT */),
          (_ctx.doesPageSupportSaving)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ChampionButton SaveBlockButton",
                disabled: !_ctx.isSaveEnabled || _ctx.isSaveOrCreationInProgress,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveCampaign && _ctx.saveCampaign(...args)))
              }, " Save Campaign ", 8 /* PROPS */, _hoisted_4))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}